import * as React from "react";
import { styled } from "@mui/system";
import TablePagination, {
  tablePaginationClasses as classes,
} from "@mui/base/TablePagination";
import axios from "axios";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { useForm } from "react-hook-form";
import UpdateSeller from "./Modals/UpdateSeller";
import { useNavigate } from "react-router-dom";
import DeleteSeller from "./Modals/DeleteSeller";
import Loading from "./pages/Loading";
import { showSuccessToast, showErrorToast } from "../Utils/toastUtils";

function ProjectData(props) {
  //navigation
  var navigate = useNavigate();

  //helpers
  const [modal, setModal] = React.useState(false);
  const [modal1, setModal1] = React.useState(false);
  const [modal3, setModal3] = React.useState(false);
  const [currentID, setCurrentID] = React.useState("");
  const [sellerData, setSellerData] = React.useState("");
  const [loading, setLoading] = React.useState("");

  //for update dont delete
  const [name, setName] = React.useState("");
  const [domain, setDomain] = React.useState("");
  const [sellerType, setSellerType] = React.useState("");
  const userType = sessionStorage.getItem("role") === "Viewer";
  const [searchQuery, setSearchQuery] = React.useState("");
  const [filteredData, setFilteredData] = React.useState([]);

  const [sellerID, setSellerID] = React.useState("");

  //props
  const rows = props.data;
  const isCheckedArray = props.isCheckedArray;
  const deleteArray2 = props.deleteArray2;
  const handleCheckboxChange = props.handleCheckboxChange;
  const handleDelete = props.handleDelete;
  const handleDeleteMany = props.handleDeleteMany;
  const getData = props.getData;

  const handleUpdate = (e) => {
    e.preventDefault();
    const postObj = {
      name: name,
      domain: domain,
      seller_type: sellerType,
    };
    let data = axios
      .put(`/api/sellers/${currentID}`, postObj, {
        headers: {
          Authorization: "Bearer " + sessionStorage.getItem("userToken"),
        },
      })
      .then((response) => {
        getData();
        showSuccessToast(
          response.data && response.data.Message
            ? response.data.Message
            : "Success"
        );

        setModal1(!modal1);
      })
      .catch((err) => {
        console.log(err);

        showErrorToast("Error!");
      });
  };

  React.useEffect(() => {
    getData();
  }, [modal3]);

  const getIndividualSellerDetails = (id) => {
    let data = axios
      .get(`/api/sellers/seller/${id}`, {
        headers: {
          Authorization: "Bearer " + sessionStorage.getItem("userToken"),
        },
      })
      .then((response) => {
        setSellerData(response.data[0]);
        setSellerID(response.data[0].seller_id);
        setName(response.data[0].name);
        setDomain(response.data[0].domain);
        setSellerType(response.data[0].seller_type);
      })
      .catch((err) => {
        console.log(err);

        showErrorToast("Error!");
      });
  };

  const clearUpdateInfo = () => {
    setSellerData([])
    setSellerID("")
    setName("")
    setDomain("")
    setSellerType("")
  }
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);

  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    showSuccessToast(
      `Rows Per Page changed to ${parseInt(event.target.value, 10)}`
    );
    setPage(0);
  };
  React.useEffect(() => {
    getData();
  }, []);
  const blue = {
    200: "#A5D8FF",
    400: "#3399FF",
  };

  const grey = {
    50: "#F3F6F9",
    100: "#E7EBF0",
    200: "#E0E3E7",
    300: "#CDD2D7",
    400: "#B2BAC2",
    500: "#A0AAB4",
    600: "#6F7E8C",
    700: "#3E5060",
    800: "#2D3843",
    900: "#1A2027",
  };

  const Root = styled("div")(
    ({ theme }) => `
    table {
      font-family: IBM Plex Sans, sans-serif;
      font-size: 0.875rem;
      border-collapse: collapse;
      width: 100%;
    }
  
    td,
    th {
      border: 1px solid ${theme.palette.mode === "dark" ? grey[800] : grey[200]
      };
      text-align: left;
      padding: 6px;
    }
  
    th {
      background-color: ${theme.palette.mode === "dark" ? grey[900] : grey[100]
      };
    }
    `
  );

  const CustomTablePagination = styled(TablePagination)(
    ({ theme }) => `
    & .${classes.spacer} {
      display: none;
    }
  
    & .${classes.toolbar}  {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 10px;
  
      @media (min-width: 768px) {
        flex-direction: row;
        align-items: center;
      }
    }
  
    & .${classes.selectLabel} {
      margin: 0;
    }
  
    & .${classes.select}{
      padding: 2px;
      border: 1px solid ${theme.palette.mode === "dark" ? grey[800] : grey[200]
      };
      border-radius: 50px;
      background-color: transparent;
  
      &:hover {
        background-color: ${theme.palette.mode === "dark" ? grey[800] : grey[50]
      };
      }
  
      &:focus {
        outline: 1px solid ${theme.palette.mode === "dark" ? blue[400] : blue[200]
      };
      }
    }
  
    & .${classes.displayedRows} {
      margin: 0;
  
      @media (min-width: 768px) {
        margin-left: auto;
      }
    }
  
    & .${classes.actions} {
      padding: 2px;
      border: 1px solid ${theme.palette.mode === "dark" ? grey[800] : grey[200]
      };
      border-radius: 50px;
      text-align: center;
    }
  
    & .${classes.actions} > button {
      margin: 0 8px;
      border: transparent;
      border-radius: 2px;
      background-color: transparent;
  
      &:hover {
        background-color: ${theme.palette.mode === "dark" ? grey[800] : grey[50]
      };
      }
  
      &:focus {
        outline: 1px solid ${theme.palette.mode === "dark" ? blue[400] : blue[200]
      };
      }
    }
    `
  );

  const handleSearch = (event) => {
    const query = event.target.value.toLowerCase();
    setSearchQuery(query);

    if (query === "") {
      setFilteredData([]); // Show all data when search query is empty
    } else {
      const filtered = rows.filter((item) =>
        item.domain.toLowerCase().includes(query)
      );
      setFilteredData(filtered);
    }
  };

  return (
    <div className="container-fluid py-4">
      <div className="row">
        <div className="col-12">
          <div className="card my-4">
            <div className="card-header p-0 position-relative mt-n4 mx-3 z-index-2">
              <div
                className="bg-gradient-info d-flex flex-row shadow-primary border-radius-lg py-2 align-items-center justify-content-between "
              >
                <h6 className="text-white text-capitalize ms-3 align-middle w-50">My Sellers</h6>
                {/* <div className="input-group input-group-outline me-3 mb-3"> */}
                <input
                  type="text"
                  className="form-control mr-2 w-25"
                  placeholder="Search Seller"
                  value={searchQuery}
                  onChange={handleSearch}
                />
              </div>
            </div>
            <div className="card-body px-4 pb-2">
              <div className="table table-responsive p-0">
                <div className="table-responsive p-0 d-flex justify-content-center align-items-center">
                  <Root sx={{ width: 1500, maxWidth: "100%" }}>
                    <table aria-label="custom pagination table">
                      <thead>
                        <tr>
                          <th style={{ width: "100px" }}>Sr No.</th>

                          <th className="text-center">Seller Id</th>
                          <th className="text-center">Name</th>
                          <th className="text-center">Domain</th>
                          <th className="text-center">Seller Type</th>
                          {!userType && <th className="text-center">Action</th>}
                        </tr>
                      </thead>
                      <tbody>
                        {(rowsPerPage > 0
                          ? rows
                            .filter((row) =>
                              row.domain
                                .toLowerCase()
                                .includes(searchQuery.toLowerCase())
                            )
                            .slice(
                              page * rowsPerPage,
                              page * rowsPerPage + rowsPerPage
                            )
                          : rows.filter((row) =>
                            row.domain
                              .toLowerCase()
                              .includes(searchQuery.toLowerCase())
                          )
                        ).map((row, index) => (
                          <tr key={row._id}>
                            <td>{index + 1}</td>
                            <td>
                              {row.seller_id
                                ? row.seller_id
                                : "No Seller ID Found"}
                            </td>
                            <td style={{ width: 240 }} align="right">
                              {row.name ? row.name : "No name"}
                            </td>
                            <td style={{ width: 240 }} align="right">
                              {row.domain ? row.domain : ""}
                            </td>
                            <td style={{ width: 240 }} align="right">
                              {row.seller_type ? row.seller_type : ""}
                            </td>
                            {!userType && (
                              <td
                                className="bg-gray-200 text-center"
                                style={{ width: 240 }}
                                align="right"
                              >
                                <button
                                  className="btn btn-link text-secondary mb-0"
                                  onClick={() => {
                                    setCurrentID(row._id);
                                    setModal3(true);
                                  }}
                                >
                                  <DeleteIcon color="action" />
                                </button>
                                <button
                                  className="btn btn-link text-secondary mb-0"
                                  onClick={() => {
                                    getIndividualSellerDetails(row._id);
                                    setCurrentID(row._id);
                                    setModal1(true);
                                  }}
                                >
                                  <EditIcon fontSize="small" color="action" />
                                </button>

                                {rows && <button className="btn btn-link text-secondary mb-0">
                                  <input
                                    type="checkbox"
                                    // checked={Array.isArray(deleteArray2) && deleteArray2.includes(row._id) || false}
                                    checked={Array.isArray(deleteArray2) && deleteArray2.includes(row._id)}
                                    // onChange={() => { handleCheckboxChange(row._id); console.log(row._id); console.log(deleteArray2)   }}
                                    onChange={() => { handleCheckboxChange(row._id) }}

                                  />
                                </button>
                                }
                              </td>
                            )}
                          </tr>
                        ))}
                        {emptyRows > 0 && (
                          <tr style={{ height: 34 * emptyRows }}>
                            <td colSpan={3} />
                          </tr>
                        )}
                      </tbody>
                      <tfoot>
                        <tr>
                          <CustomTablePagination
                            rowsPerPageOptions={[
                              5,
                              10,
                              25,
                              { label: "All", value: -1 },
                            ]}
                            colSpan={6}
                            count={rows.length}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            slotProps={{
                              select: {
                                "aria-label": "rows per page",
                              },
                              actions: {
                                showFirstButton: true,
                                showLastButton: true,
                              },
                            }}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                          />
                        </tr>
                      </tfoot>
                    </table>
                  </Root>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <UpdateSeller
        modal1={modal1}
        setModal1={setModal1}
        setModal={setModal}
        name={name}
        domain={domain}
        sellerType={sellerType}
        setSellerType={setSellerType}
        setName={setName}
        setDomain={setDomain}
        handleUpdate={handleUpdate}
        clearUpdateInfo={clearUpdateInfo}
        sellerID={sellerID}
      />
      <DeleteSeller
        // submit={submit}
        getData={getData}
        modal3={modal3}
        setModal3={setModal3}
        id={currentID}
      />
    </div>
  );
}

export default ProjectData;